import loadingImage from '@/assets/images/common/loading-100.gif';
import { useStyle } from '@/classify';
import Image from 'next/image';
import defaultClasses from './indicator.module.css';

const LoadingIndicator = props => {
  const { size = 100 } = props;
  const classes = useStyle(defaultClasses, props.classes);
  const className = props.global ? classes.global : classes.root;

  return (
    <div className={className}>
      <Image
        width={size}
        height={size}
        src={loadingImage}
        alt=''
      />
    </div>
  );
};

export default LoadingIndicator;
